import styled from "styled-components";

export const ContainerFlexColumn = styled.div`
width: 100%;
display: flex;
align-items: center;
flex-direction: column;
`;
